
/**
 * Returns a date object with the given number of months added.
 * Negative values are acceptable for months.
 * 
 * @param {date} A JS date object.
 * @param months An number of months.
 */
export function addMonthsToDate(date, months) {
  date.setMonth(date.getMonth() + months);
  return date;
}


/**
 * Returns text with decoded HTML entities (eg. &#038; becomes &)
 * 
 * @param 'html' String The html string
 */
export function decodeHTML(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}


/**
 * Returns a specific taxonomy object from the taxonomies array
 * with a name that matches the provided string.
 * 
 * @param parent  The taxonomy ID to find
 * @param [terms] An array of taxonomy objects that looks like [ {name: 'taxonomy-name', terms: [ ... ] } ]
 */
export function findChildTermsByID(parent, terms) {
  let matches = [];
  for (let i=0; i<terms.length; i++) {
    if (terms[i].parent === parent) {
      matches.push(terms[i]);
    }
  }
  return matches;
}


/**
 * Returns a specific taxonomy object from the taxonomies array
 * with a name that matches the provided string.
 * 
 * @param 'name' The taxonomy name to find (eg. 'taxonomy-name')
 * @param [terms] An array of taxonomy objects that looks like [ {name: 'taxonomy-name', terms: [ ... ] } ]
 */
export function findTaxonomyObjectByName(name, terms) {
  function search(terms) { return terms.name === name; }
  return terms.find(search);
}

/**
 * Returns a specific taxonomy object from the taxonomies array
 * with an ID number that matches the provided number.
 * 
 * @param id  The taxonomy ID to find (eg. 12)
 * @param [terms] An array of taxonomy objects that looks like [ {name: 'taxonomy-name', terms: [ ... ] } ]
 */
export function findTaxonomyObjectByID(id, terms) {
  function search(terms) { return terms.id === id; }
  return terms.find(search);
}

/**
 * Accepts a window.location.search and returns it as an object.
 * 
 * @param 'search' window.location.search
 */
export function searchToObject(search) {
  var pairs = search.substring(1).split("&"),
    obj = {},
    pair,
    i;

  for ( i in pairs ) {
    if ( pairs[i] === "" ) continue;

    pair = pairs[i].split("=");
    obj[ decodeURIComponent( pair[0] ) ] = decodeURIComponent( pair[1] );
  }

  return obj;
};

export function hashToObjectArray(hash) {
  var pairs = hash.substring(1).split("&"),
  arr = [],
  pair,
  i;

  for ( i in pairs ) {
    if ( pairs[i] === "" ) continue;

    pair = pairs[i].split("=");
    arr.push({
      prop: decodeURIComponent(pair[0]),
      value: decodeURIComponent( pair[1] )
    });
  }
  return arr;
}




export function isEquivalent(a, b) {
    // Create arrays of property names
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);

    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length != bProps.length) {
        return false;
    }

    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];

        // If values of same property are not equal,
        // objects are not equivalent
        if (a[propName] !== b[propName]) {
            return false;
        }
    }

    // If we made it this far, objects
    // are considered equivalent
    return true;
}


// WEBPACK FOOTER //
// ./src/helpers.js